import { CardForm, RyftProvider } from "@ryftpay/react";
import { useRyftPayment } from "./useRyftPayment";

export const RyftCardForm = () => {
  const {
    paymentSessionId,
    clientSecret,
    ryftAccountId,
    ryftPublicKey,
    cardFormInstanceRef,
    cardFormValidationEvent,
    setCardFormValidationEvent,
  } = useRyftPayment();

  if (!paymentSessionId || !clientSecret || !ryftAccountId) {
    return null;
  }

  const validationErrors = cardFormValidationEvent?.validationErrors ?? [];

  return (
    <RyftProvider
      key={paymentSessionId}
      publicKey={ryftPublicKey}
      clientSecret={clientSecret}
      accountId={ryftAccountId}
    >
      <div className="flex flex-col gap-2">
        <CardForm
          ref={cardFormInstanceRef}
          displayConfig={{ fieldLayout: "separated" }}
          onValidationChange={setCardFormValidationEvent}
        />
        {validationErrors.length > 0 && (
          <ul className="list-inside list-disc text-sm text-red-600">
            {validationErrors.map((error, index) => (
              <li key={index}>{error.message}</li>
            ))}
          </ul>
        )}
      </div>
    </RyftProvider>
  );
};
